// Converts "test_{Label1}_{Label2}" → "test_{id1}_{id2}"
export const convertFileNameToIds = (fileName, columnOptions) => {
  if (!fileName) return fileName;

  return fileName.replace(/\{([^}]+)\}/g, (match, label) => {
    const found = columnOptions.find(
      (opt) => opt.label?.toLowerCase() === label.toLowerCase()
    );
    return found ? `{${found._id}}` : match;
  });
};

// Converts "test_{id1}_{id2}" → "test_{Label1}_{Label2}"
export const revertFileNameToLabels = (fileName, columnOptions) => {
  if (!fileName) return fileName;

  return fileName.replace(/\{([^}]+)\}/g, (match, id) => {
    const found = columnOptions.find((opt) => opt._id === id);
    return found ? `{${found.label}}` : match;
  });
};